<div class="wrap-box">
  <div class="box">
    <form [formGroup]="form" *ngIf="form">
      <div class="header">
        <span>ราคา</span>
        <span class="itax-dropdown">
            <app-dropdown [items]="dropdownItems"
                          id="calType"
                          [(selected)]="selectedItem"
                          (valueChange)="onDdlItemClick($event)">
            </app-dropdown>
        </span>
      </div>
      <div class="mb-20px wrap-input">
        <app-input-number [(value)]="total"
                          (valueChange)='onNumberChange()'>
        </app-input-number>
      </div>
      <div class="row d-flex align-items-center mb-10px">
        <div class="col pl-0">
          ภาษีมูลค่าเพิ่ม (VAT)
        </div>
        <div class="col input-tax">
          <div class="input-group mb-0">
            <input type="text" class="form-control" placeholder="" inputmode="decimal"
              formControlName="vat"
              itaxNumberOnly
            />
            <span class="wrap-percent">%</span>
          </div>
        </div>
      </div>
      <div class="row d-flex align-items-center mb-20px">
        <div class="col pl-0">
          หักภาษี ณ ที่จ่าย
        </div>
        <div class="col input-tax">
          <div class="input-group mb-0">
            <input type="text" class="form-control" placeholder="" inputmode="decimal"
              formControlName="tax"
              itaxNumberOnly
            />
            <span class="wrap-percent">%</span>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-primary btn-block py-12px"
              (click)="calculateTax()">
        คำนวณ
      </button>
    </form>
  </div>
</div>
